// One photograph per trade, shared by the home rail and the industries pages.
// Each file ships at 1600px with an 800px variant; the cool morning grade is
// applied in CSS (industry-photos.css), never baked into the file.
export type IndustryPhoto = {
  src: string;
  srcSmall: string;
  width: number;
  height: number;
  alt: string;
};

export const INDUSTRY_PHOTOS: Record<string, IndustryPhoto> = {
  hvac: {
    src: "/photos/industries/hvac-1600.webp",
    srcSmall: "/photos/industries/hvac-800.webp",
    width: 1600,
    height: 1067,
    alt: "A technician in work gloves servicing a rooftop condenser, gauges and a wrench beside a ringing phone",
  },
  dental: {
    src: "/photos/industries/dental-1600.webp",
    srcSmall: "/photos/industries/dental-800.webp",
    width: 1600,
    height: 1067,
    alt: "An empty dental front desk with a desk phone and headset, the treatment room visible through the doorway",
  },
  plumbing: {
    src: "/photos/industries/plumbing-1600.webp",
    srcSmall: "/photos/industries/plumbing-800.webp",
    width: 1600,
    height: 1067,
    alt: "A plumber turning a valve under a sink with a pipe wrench, a phone propped against the cabinet",
  },
  "auto-dealer": {
    src: "/photos/industries/auto-dealer-1600.webp",
    srcSmall: "/photos/industries/auto-dealer-800.webp",
    width: 1600,
    height: 1067,
    alt: "A dealership service counter with a key fob on a clipboard and a phone beside it, the lot beyond the glass",
  },
  salon: {
    src: "/photos/industries/salon-1600.webp",
    srcSmall: "/photos/industries/salon-800.webp",
    width: 1600,
    height: 1067,
    alt: "A stylist cutting hair with shears and comb, clippers and bottles on the station below",
  },
  "med-spa": {
    src: "/photos/industries/med-spa-1600.webp",
    srcSmall: "/photos/industries/med-spa-800.webp",
    width: 1600,
    height: 1067,
    alt: "A quiet treatment room with a folded towel, a tablet and a phone on the counter beside the chair",
  },
  "lawn-care": {
    src: "/photos/industries/lawn-care-1600.webp",
    srcSmall: "/photos/industries/lawn-care-800.webp",
    width: 1600,
    height: 1067,
    alt: "Work gloves and a phone on an open truck tailgate, a mower on the trailer behind it",
  },
};

export const industryPhoto = (slug: string): IndustryPhoto | undefined =>
  INDUSTRY_PHOTOS[slug];
